import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { InlineInput } from '../InlineInput'
import { Tags } from './Tags'
import { TagsInput } from './TagsInput'

const defaultRenderInput =
  ({ onKeyDown: onKeyDownCore, onBlur: onBlurCore }) =>
  (props) => {
    const { onChange, value, onBlur, onKeyDown, ...other } = props
    let finalOnKeydown = onKeyDown
    let finalOnBlur = onBlur

    if (isEmpty(value)) {
      finalOnKeydown = onKeyDownCore
      finalOnBlur = onBlurCore
    }

    return (
      <input
        type="text"
        onChange={onChange}
        value={value}
        {...{
          ...other,
          onBlur: finalOnBlur,
          onKeyDown: finalOnKeydown,
        }}
      />
    )
  }

export const TagsInlineInput = ({ parentInputComponent, editContent, displayContent, inputProps, ...rest }: any) => {
  const ParentInput = parentInputComponent || InlineInput
  displayContent = displayContent ?? ((tagArray = []) => <Tags dataArray={tagArray} className={inputProps?.className} />)

  editContent =
    editContent ??
    (({ onKeyDown, onBlur, value, setNewValue, submitting }) => (
      <TagsInput
        submitting={submitting}
        {...inputProps}
        value={value}
        onChange={(e) => setNewValue(e)}
        renderInput={defaultRenderInput({ onKeyDown, onBlur })}
      />
    ))
  return (
    <ParentInput
      {...{
        ...rest,
        displayContent,
        editContent,
      }}
    />
  )
}
